export const emptyQueryParams = ({ oldParamsString, url }) => {
  oldParamsString.split('&').map((keyValue) => {
    const splitted = keyValue.split('=');
    const key = splitted?.[0];
    if (key) {
      url.searchParams.delete(key);
    }
  });
};

export const updateQueryParams = ({
  filterUrlQuery,
  url,
  isBiennali = false,
}) => {
  if (url) {
    const oldParamsString = url.search?.slice(1);
    if (oldParamsString) {
      emptyQueryParams({ oldParamsString, url });
    }
    const filteredUrlQuery = isBiennali
      ? filterUrlQuery
          .split('&')
          .filter((keyValue) => !keyValue.includes('anno='))
      : filterUrlQuery.split('&');
    filteredUrlQuery.map((keyValue) => {
      const splitted = keyValue.split('=');
      const key = splitted?.[0];
      const value = splitted?.[1];
      if (key && value && key !== 'pageSize') {
        url.searchParams.set(key, value);
      }
    });
    window.history.replaceState(null, null, url);
  }
};

export const createFiltersFormParams = ({ url }) => {
  const paramsString = url.search?.slice(1);
  const filtersMapping = {
    nome: 'search',
    iniziale: 'alphabet', //
    nazionalita: 'nation', //
    evento: 'exhibitors',
    appuntamenti: 'visits',
    hall: 'hall', //
    categoria: 'category',
    prodotto: 'product',
    percorsiTematici: 'itinerary', //
    pageNumber: 'pageNumber',
  };
  const urlMappedfilters = {};
  paramsString.split('&').map((keyValue) => {
    const splitted = keyValue.split('=');
    const azureKey = splitted?.[0];
    const value = splitted?.[1];
    if (Object.keys(filtersMapping).find((k) => k === azureKey)) {
      if (azureKey === 'evento') {
        const values = value.split('%7C');
        if (azureKey && values?.length)
          urlMappedfilters[filtersMapping[azureKey]] = values;
      } else if (azureKey === 'nome') {
        if (azureKey && value) {
          urlMappedfilters[filtersMapping[azureKey]] =
            decodeURIComponent(value);
        }
      } else {
        if (azureKey && value) {
          urlMappedfilters[filtersMapping[azureKey]] = value;
        }
      }
    }
  });

  if (!urlMappedfilters.search) urlMappedfilters.search = '';
  if (!urlMappedfilters.pageNumber) urlMappedfilters.pageNumber = '1';
  return urlMappedfilters;
};
